import { useState } from 'react';

import cn from '@/lib/clsxm';
import { useClientExtraLargeScreen } from '@/lib/user-agent/client';

import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import XImage from '@/components/@base/x-image';
import { useTableContentItems } from '@/components/app/product/components/table-contents/constant';
import TableContentsList from '@/components/app/product/components/table-contents/table-contents-list';

import imagesList from '@/constant/images-list';

export default function TableContents({ onSelectTab, activeItem, hasReviews, hasQuestions }) {
  const [open, setOpen] = useState(false);
  const items = useTableContentItems({ hasReviews, hasQuestions });
  const isExtraLarge = useClientExtraLargeScreen();
  const toggleDrawer = () => setOpen((prev) => !prev);

  if (isExtraLarge) {
    return (
      <Container className='z-10! rounded-md bg-white pt-[25px] pr-[9px] pb-[19px] pl-[10px]'>
        <TableContentsList
          items={items}
          activeItem={activeItem}
          onSelectTab={onSelectTab}
          isExtraLarge={isExtraLarge}
          itemClassName='relative h-[52px] w-[251px] flex items-center! justify-start! rounded-md bg-white pt-2.5 pb-0 pr-[28px] text-start! hover:bg-[#FFF7EA]'
          textClassName='text-[14px]! font-bold! text-[#5B5C60] pt-1!'
          wrapperClassName='2xl:pr-[28px]! pr-[14px]! pb-[13px]  whitespace-nowrap '
        />
      </Container>
    );
  }

  return (
    <>
      <Container className='z-50'>
        <Button
          onClick={toggleDrawer}
          onMouseEnter={() => setOpen(true)}
          className='rotate-90 bg-transparent'
        >
          <XImage
            className='relative w-16 rotate-270 md:w-16'
            src={imagesList.backgrounds.productsList}
            alt='tableContentsBG'
          />
        </Button>
      </Container>
      <Container
        className={cn(
          'fixed inset-0 bg-black/30 transition-opacity duration-300',
          open ? 'opacity-100' : 'pointer-events-none opacity-0',
        )}
        onClick={toggleDrawer}
      />
      <Container
        onMouseLeave={() => setOpen(false)}
        className={cn(
          'fixed top-[390px] right-0 z-70 max-h-[285px] min-h-[205px] w-[225px] rounded-md bg-white pt-1.5 pr-1.5 pb-1 pl-2 shadow-lg transition-transform duration-300 ease-in-out md:top-61',
          open ? 'translate-x-0' : 'translate-x-full',
        )}
      >
        <TableContentsList
          items={items}
          activeItem={activeItem}
          onSelectTab={onSelectTab}
          isExtraLarge={isExtraLarge}
          closeDrawer={() => setOpen(false)}
          itemClassName='relative h-[36px]! w-full items-center! justify-start! rounded-md pr-[28px] text-start leading-8! hover:bg-[#FFF7EA]'
          textClassName='text-[13px]  text-[#5B5C60]'
          wrapperClassName='2xl:pr-[28px] pr-[10px]! pt-2 pb-3 whitespace-nowrap'
        />
      </Container>
    </>
  );
}
